export default __webpack_public_path__ + "static/media/Voucher.9f0970a2.svg";